import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'Components';
import classNames from 'classnames';
import FormikSelectField from './Formik';
import './SelectField.css';

const SelectField = ({
  options,
  title,
  required,
  hasError,
  startBlank,
  placeholder,
  className,
  isLoading,
  uniqueKey,
  isclearable,
  ...rest
}) => {
  const { deletionState } = useContext(DeletionContext);
  return (
    <div
      hidden={deletionState.isDeletionModeActive}
      className={classNames(
        'select-field',
        { 'select-field__error': hasError },
        className,
      )}
    >
      {title && (
        <div className="select-field__label">
          <span>{title}</span>
          {required && <span className="select-field__required">*</span>}
        </div>
      )}

      {isLoading && (
        <div className="select-field__loader">
          <Loader isSmall isSolidWhite />
        </div>
      )}

      {!isLoading && (
        <select {...rest} required={required}>
          {startBlank && (
            <option disabled value="">
              {placeholder}
            </option>
          )}
          {/* Conditionally render Clear selection option if clearable is true */}
          {isclearable && <option style={{fontWeight:'bold'}} value="">Clear selection</option>}
          {(options || []).map((option) => (
            <option key={option[uniqueKey]} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

SelectField.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ),
  uniqueKey: PropTypes.string,
  title: PropTypes.string,
  hasError: PropTypes.bool,
  required: PropTypes.bool,
  startBlank: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  isclearable: PropTypes.bool,
};

SelectField.defaultProps = {
  placeholder: '',
  uniqueKey: 'value',
};

SelectField.Formik = FormikSelectField;
export default SelectField;



// WEBPACK FOOTER //
// ./src/components/SelectField/SelectField.jsx